import { action } from "easy-peasy";

export default {
  profile: {
    index: 0,
    resume: {
      photo: null,
      resumeFile: null,
    },
  },
  recruiter: {
    scheduleState: {
      type: "",
      interviewer: null,
      companyName: "",
      designation: "",
      date: null,
      duration: null,
      candidate: "",
      candidateMail: "",
      candidatePhone: "",
      note: "",
    },
  },
  setScheduleDate: action((state, date) => {
    state.recruiter.scheduleState.date = date;
  }),
  setSchedule: action((state, scheduleStateObj) => {
    state.recruiter.scheduleState.type = scheduleStateObj.type;
    state.recruiter.scheduleState.interviewer = scheduleStateObj.interviewer;
    state.recruiter.scheduleState.companyName = scheduleStateObj.companyName;
    state.recruiter.scheduleState.designation = scheduleStateObj.designation;
    state.recruiter.scheduleState.duration = scheduleStateObj.duration;
    state.recruiter.scheduleState.candidate = scheduleStateObj.candidate;
    state.recruiter.scheduleState.candidateMail =
      scheduleStateObj.candidateMail;
    state.recruiter.scheduleState.candidatePhone =
      scheduleStateObj.candidatePhone;
    state.recruiter.scheduleState.note = scheduleStateObj.note;
  }),

  setResume: action((state, resumeStateObj) => {
    state.profile.resume.photo = resumeStateObj.image;
    state.profile.resume.resumeFile = resumeStateObj.resumeFile;
    // console.log({...state.profile.resume});
  }),
  setIndex: action((state, index) => {
    if (index < 6) {
      state.profile.index = index;
    }
  }),
  decreaseIndex: action((state, index) => {
    if (state.profile.index > 0) {
      state.profile.index = index;
    }
  }),
  // show: action((state) => {
  //   console.log(state.profile.resume.photo);
  // }),
};
